module.exports = __webpack_public_path__ + "static/media/X-Line.c12f6902.jpg";